import React from 'react';
import './Thinwalled.css';
import thinwalldis from '../../../imgs/thinwalldishable.webp';

const Thinwalled = () => {
    return (
        <div className="Material-container">
            <div className='Materialsl'>
                <h2 className="Material-title">Thin-walled Disposable Food Box Injection Production Equipment</h2>
                <p className="Material-date">Sep. 21, 2022</p>
                <div className="advantpl">
                    <img src={thinwalldis} alt="72 Cavity PET Preforms Machine" className="advantpla-image" />
                </div>
                <p className="Material-date">Disha KF series high-speed thin-wall
                    special injection molding machine</p>
                <p className="Material-text"> is a high-end product developed by integrating decades
                    of experience and absorbing advanced technology from other countries. It solves
                    the problems of high pressure, high temperature, slow production cycle,
                    and poor mechanical structure existing in
                    the production of thin-wall products by most of the current fast-moving machines.</p>
                <p className="Material-text">KF series is dedicated to the production of high-end food
                     and other thin-walled packaging containers, such as disposable high-end PP
                     material ice cream cups, yogurt cups, milk tea cups, food boxes, etc.</p>

            </div>
        </div>
    );
};
export default Thinwalled;
